import { registerTourProduct } from '../onboardingTourFactory';

/**
 * The tour of the "Accounts >> Users" page.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} {
 *  steps: [...],
 *  novusPagePath: string|false,
 *  novusProps: Will be declared in OnboardingTourContainer.
 * }
 */
const createTour = (t) => {
  const novusProps = {
    changePage: () => {},
    setSearchText: () => {},
    fullName: ''
  };
  /**
   * Updates the User Search data.
   *
   * @param {string} text
   */
  const updateSearch = (text) => {
    novusProps.setSearchText({
      text,
      fields: [],
      searchAllFields: true
    });
    novusProps.changePage(0);
  };

  return {
    disableInteraction: true,
    novusPagePath: 'accounts/users',
    novusProps,
    steps: [
      {
        element: '.onboarding-tour.user-search-container',
        novusTrackingId: 'accounts-users-search',
        position: 'left',
        intro: t(
          'Now let’s take a look at user accounts! We’ve entered your name in the search bar to show you how it works.'
        ),
        /**
         * Called as this step is shown.
         *
         * @param {Element} element
         */
        novusOnChange: function(element) {
          clearTimeout(this._novusTypingTimeout);

          const inputs = element ? element.getElementsByTagName('input') : null;
          // Fastest human typing is around 150 ms per char.
          const TYPING_DELAY_MS = 100;
          const UPDATE_CHAR_THRESHOLD = 5;
          const INTROJS_SHOW_ELEMENT = 'introjs-showElement';

          if (inputs && inputs.length) {
            const searchField = inputs[0];
            searchField.value = '';
            updateSearch(searchField.value);

            const typeSearchByLetter = (name, inputLength = 0) => {
              if (inputLength <= name.length) {
                searchField.blur();
                searchField.value = name.substring(0, inputLength);

                if (inputLength % UPDATE_CHAR_THRESHOLD === 1) {
                  updateSearch(searchField.value);
                }
                // We can exit the tour at any moment; only continue if we remain on this step.
                if (element.classList.contains(INTROJS_SHOW_ELEMENT)) {
                  this._novusTypingTimeout = setTimeout(
                    () => typeSearchByLetter(name, inputLength + 1),
                    TYPING_DELAY_MS
                  );
                  return;
                }
              }
              updateSearch(searchField.value);
            };
            this._novusTypingTimeout = setTimeout(
              () => typeSearchByLetter(novusProps.fullName),
              TYPING_DELAY_MS
            );
          }
        },
        /**
         * Called before the next step is shown.
         *
         * @param {Element} element
         * @param {Element} nextElement
         * @return {boolean} True to continue, false to stay.
         */
        novusOnReadyForNext: (element, nextElement) => {
          if (nextElement && !nextElement.classList.contains('showSearch')) {
            return false;
          }
          const inputs = element ? element.getElementsByTagName('input') : null;
          return inputs && inputs.length ? inputs[0].value.length > 0 : true;
        }
      },
      {
        element: '.onboarding-tour.search-filter-container',
        novusTrackingId: 'accounts-users-search-filters',
        position: 'left',
        intro: t(
          'For faster results, you can use filters to locate a user account.'
        )
      },
      {
        element: '.onboarding-tour.edit-user-button-container',
        novusTrackingId: 'accounts-users-edit',
        intro: t("You can view and edit the user's account here."),
        /**
         * Called when tour exits this page.
         */
        novusOnReadyForNext: () => {
          updateSearch('');
          return true;
        }
      }
    ]
  };
};

export const tourName = 'accountsUsersTour';
registerTourProduct(tourName, createTour);



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/accountsUsersTour.js